import { render, staticRenderFns } from "./prescription-add-blurb-popup.vue?vue&type=template&id=63dd0920&scoped=true"
import script from "./prescription-add-blurb-popup.vue?vue&type=script&lang=js"
export * from "./prescription-add-blurb-popup.vue?vue&type=script&lang=js"
import style0 from "./prescription-add-blurb-popup.vue?vue&type=style&index=0&id=63dd0920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63dd0920",
  null
  
)

export default component.exports